export enum ActionTypes {
  GET_USER_ACCOUNTS_REQUEST = '@@user/GET_USER_ACCOUNTS_REQUEST',
  GET_USER_ACCOUNTS_SUCCESS = '@@user/GET_USER_ACCOUNTS_SUCCESS',
  GET_USER_ACCOUNTS_FAILURE = '@@user/GET_USER_ACCOUNTS_FAILURE',
};